var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pz-query-text-view"},[_vm._l((_vm.fragments),function(f,index){return [_c('text-fragment',{key:index,attrs:{"text":f.text,"type":f.type}}),_vm._v(" "),_c('wbr',{key:index+ 'wbr'})]}),(_vm.textError)?_c('error-message',{attrs:{"errors":[_vm.textError],"title":_vm.textErrorTitle,"message":_vm.textErrorMessage}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }